import { apiClient } from '@/shared/api/http-client';

import type {
    AddServiceInput,
    ServiceCatalog,
    UpdateServiceInput,
    UpdateServiceRatesInput,
} from '../model/service-catalog.types';

export const serviceCatalogApi = {
    get: async (signal?: AbortSignal): Promise<ServiceCatalog> => {
        return apiClient.get('/practices/me/service-catalog', signal);
    },
    addService: async (data: AddServiceInput, signal?: AbortSignal): Promise<void> => {
        return apiClient.post('/practices/me/service-catalog/services', data, signal);
    },
    updateService: async (
        code: string,
        data: UpdateServiceInput,
        signal?: AbortSignal,
    ): Promise<void> => {
        return apiClient.patch(
            `/practices/me/service-catalog/services/${encodeURIComponent(code)}`,
            data,
            signal,
        );
    },
    deleteService: async (code: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.delete(
            `/practices/me/service-catalog/services/${encodeURIComponent(code)}`,
            signal,
        );
    },
    setDefaultService: async (code: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.post(
            `/practices/me/service-catalog/services/${encodeURIComponent(code)}/default`,
            undefined,
            signal,
        );
    },
    updateRates: async (data: UpdateServiceRatesInput, signal?: AbortSignal): Promise<void> => {
        return apiClient.patch('/practices/me/service-catalog/rates', data, signal);
    },
};
